/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Delete_BodyInputs */

const en_us2_profile_editors_delete_body = /** @type {(inputs: Profile_Editors_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account is closed and can't be reopened or recovered later. Your conversations with the trainer are deleted.`)
};

const pt_br2_profile_editors_delete_body = /** @type {(inputs: Profile_Editors_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua conta é encerrada e não dá para reabrir nem recuperar depois. As conversas com o personal são apagadas.`)
};

const es_419_profile_editors_delete_body = /** @type {(inputs: Profile_Editors_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta se cierra y no se puede reabrir ni recuperar después. Tus conversaciones con el entrenador se borran.`)
};

const pt_pt2_profile_editors_delete_body = /** @type {(inputs: Profile_Editors_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua conta é encerrada e não pode ser reaberta nem recuperada depois. As conversas com o treinador são apagadas.`)
};

const fr_fr2_profile_editors_delete_body = /** @type {(inputs: Profile_Editors_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton compte est fermé et ne pourra être ni rouvert ni récupéré. Tes conversations avec le coach sont supprimées.`)
};

const de_de2_profile_editors_delete_body = /** @type {(inputs: Profile_Editors_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Konto wird geschlossen und kann später weder wieder geöffnet noch wiederhergestellt werden. Deine Gespräche mit dem Coach werden gelöscht.`)
};

const it_it2_profile_editors_delete_body = /** @type {(inputs: Profile_Editors_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo account viene chiuso e non potrà essere riaperto né recuperato. Le conversazioni con il coach vengono eliminate.`)
};

/**
* | output |
* | --- |
* | "Your account is closed and can't be reopened or recovered later. Your conversations with the trainer are deleted." |
*
* @param {Profile_Editors_Delete_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_delete_body = /** @type {((inputs?: Profile_Editors_Delete_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Delete_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_delete_body(inputs)
	if (locale === "es-419") return es_419_profile_editors_delete_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_delete_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_delete_body(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_delete_body(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_delete_body(inputs)
	return en_us2_profile_editors_delete_body(inputs)
});
export { profile_editors_delete_body as "profile-editors.delete_body" }